import 'semantic-ui-css/semantic.min.css';
import React from 'react';
import { Card, Icon } from 'semantic-ui-react';

const generateExtra = (date, icon) => (
	<span>
		<Icon name={icon} />
		{date}
	</span>
);

const SemanticCard = (props) => {
	const { image, header, meta, description, extra, onClick } = props;
	return (
		<Card
			image={image}
			header={header}
			meta={meta}
			description={description}
			extra={generateExtra(extra.date, extra.icon)}
			onClick={onClick}
		/>
	);
};

export default SemanticCard;



// WEBPACK FOOTER //
// ./src/components/common/SemanticCard.js